import React, { useEffect, useState } from "react";
import "../styles/Order.css";
import ProductCard from "../components/ProductCard";
import CartSummary from "../components/CartSummary";

import item1 from "../assets/images/store/1.png";
import item2 from "../assets/images/store/2.png";
import item3 from "../assets/images/store/3a.png";
import {
  addDomainInImage,
  apiRequest,
  getFormattedResponse,
} from "../core/utils";
import OrderSkeleton from "../components/OrderSkeleton";
import CartSummarySkeleton from "..//components/CartSummarySkeleton";

import {
  handleResponseMessage,
  onChangeHandler,
} from "npm-solvitize/utils/Common";
import { orderApi, productsApi, contestApi } from "../core/api_endpoints";
import { useAuth } from "../context/AuthContext";

const pageName = "Order";
function Order() {
  const { user } = useAuth();

  const [quantities, setQuantities] = useState({});

  const [data, setData] = useState([]);

  const [order_data, setOrderData] = useState([]);

  const [showQtyModal, setShowQtyModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [contestData, setContestData] = useState(null);
  const [tempQty, setTempQty] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingContest, setLoadingContest] = useState(false);
  const [placeOrderLoading, setPlaceOrderLoading] = useState(false);

  const getData = async (page = 1) => {
    // if (page == undefined) page = 1

    // alert("Fetching organizations list")
    setLoading(true);
    let response = await apiRequest(`${productsApi}?page=${page}`, "GET", {
      pagination: 0,
    });

    console.log("Main Response", response);

    if (response.status) {
      setLoading(false);
      setData(response.data);
      console.log("Data loaded successfully", response.data);
    }
    setLoading(false);
    let message = handleResponseMessage(response.status, response.message);
    // alert(`${pageName} data ${response.status ? "" : "not "}loaded`, response.status ? "success" : "error", 5000, "top center")
    // setIsPageLoaded(true)
  };

  const fetchContestData = async () => {
    try {

      let month = new Date().getMonth() + 1;
      let year = new Date().getFullYear();
      setLoadingContest(true);
      let response = await apiRequest(
        `${contestApi}?month=${month}&year=${year}`,
        "GET"
      );
      if (response.status) {
        const formattedContestData = getFormattedResponse(response.data);
        setContestData(formattedContestData);
        // console.log("Contest Data", formattedContestData);
      }
    } catch (error) {
      console.error("Error fetching contest data:", error);
    } finally {
      setLoadingContest(false);
    }
  };
  useEffect(() => {
    console.log("User Token ", user);
    getData();
    fetchContestData();
  }, []);

  const updateQuantity = (item, delta) => {
    setOrderData((prevOrderData) => {
      const existingIndex = prevOrderData.findIndex((i) => i.id === item.id);
      let updatedOrder = [...prevOrderData];

      if (existingIndex !== -1) {
        const existingItem = updatedOrder[existingIndex];
        const newQty = existingItem.qty + delta;

        if (newQty <= 0) {
          updatedOrder.splice(existingIndex, 1); // remove
        } else {
          updatedOrder[existingIndex] = {
            ...existingItem,
            qty: newQty, // ✅ immutably update
          };
        }
      } else if (delta > 0) {
        updatedOrder.push({
          id: item.id,
          name: item.name,
          price: item.price,
          qty: 1,
        });
      }

      return updatedOrder;
    });
  };

  const getQty = (itemId) => {
    const found = order_data.find((i) => i.id === itemId);
    return found ? found.qty : 0;
  };

  const getTotalBill = () => {
    return order_data.reduce((total, item) => total + item.qty * item.price, 0);
  };

  const openQtyModal = (item) => {
    setSelectedItem(item);
    setTempQty(getQty(item.id));
    setShowQtyModal(true);
  };

  const updateQtyFromModal = () => {
    if (selectedItem && tempQty >= 0) {
      if (tempQty === 0) {
        // Remove item completely
        setOrderData((prev) => prev.filter((i) => i.id !== selectedItem.id));
      } else {
        // Directly set the quantity
        setOrderData((prevOrderData) => {
          const existingIndex = prevOrderData.findIndex(
            (i) => i.id === selectedItem.id
          );
          let updatedOrder = [...prevOrderData];

          if (existingIndex !== -1) {
            // Update existing item with new quantity
            updatedOrder[existingIndex] = {
              ...updatedOrder[existingIndex],
              qty: tempQty,
            };
          } else {
            // Add new item with specified quantity
            updatedOrder.push({
              id: selectedItem.id,
              name: selectedItem.name,
              price: selectedItem.price,
              qty: tempQty,
            });
          }

          return updatedOrder;
        });
      }
    }
    setShowQtyModal(false);
  };

  const handleSubmit = async () => {
    // const formErrors = validateInput(data, config.validations);
    // if (Object.keys(formErrors).length > 0) {
    //     setErrors(formErrors);
    //     alert(`${Object.keys(formErrors)[0]} : ${formErrors[Object.keys(formErrors)[0]]} `, "error", 5000);
    //     return; // Prevent submission if there are errors
    // }
    if (order_data.length === 0) {
      alert(
        "Your order is empty. Please add items to your order before submitting.",
        "error",
        5000
      );
      return;
    }

    let url = `${orderApi}`;
    let method = "POST";
    try {
      setPlaceOrderLoading(true);
      let payload = {
        items_list: JSON.stringify(order_data),
        created_at: new Date().toISOString(),
      };
      console.log("Payload to be sent", payload);
      let response = await apiRequest(url, method, payload);

      if (response.status) {
        console.log("Response", response);
      }
      let message = handleResponseMessage(response.status, response.message);

      alert(message, response.status ? "success" : "error", 5000, "top center");

      if (response.status) {
        // navigate with updated state
        console.log("Response", response);
        //clear order data
        setOrderData([]);
        // navigate(`${current_page_path}/${response.data.id}`, {
        //     state: { item: response.data, page: 1 }, // Pass the updated item in state
        //     replace: true, // This will replace the current state and URL
        // });
      }
    } catch (error) {
      console.error("Error during order submission:", error);
      alert(
        "An error occurred while submitting your order. Please try again.",
        "error",
        5000
      );
    } finally {
      setPlaceOrderLoading(false);
    }
  };
  if (loading) {
    return <OrderSkeleton />;
  }
  return (
    <div className="order-container">
      <h1 className="order-title">Products</h1>

      <div className="products-container">
        {data.map((item) => (
          <ProductCard
            key={item.id}
            item={item}
            getQty={getQty}
            updateQuantity={updateQuantity}
            openQtyModal={openQtyModal}
          />
        ))}
      </div>
      {loadingContest ? (
        <CartSummarySkeleton />
      ) : (
        <CartSummary getTotalBill={getTotalBill} contestData={contestData} />
      )}

      <div className="place-order-btn" onClick={() => handleSubmit()}>
        {placeOrderLoading ? (
          <>
            <i className="fa fa-spinner fa-spin me-2"></i>
            Placing Order...
          </>
        ) : (
          <h2 className="place-order-text">Place Your Order</h2>
        )}
      </div>

      {/* Quantity Edit Modal */}
      {showQtyModal && (
        <div className="modal-overlay" onClick={() => setShowQtyModal(false)}>
          <div
            className="modal-content d-flex justify-content-center align-items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Edit Quantity</h3>
            <p>{selectedItem?.name}</p>
            <input
              type="number"
              min="0"
              value={tempQty}
              onChange={(e) => setTempQty(parseInt(e.target.value))}
              className="modal-input"
            />
            <div className="modal-buttons">
              <button
                onClick={() => setShowQtyModal(false)}
                className="modal-btn-cancel"
              >
                Cancel
              </button>
              <button onClick={updateQtyFromModal} className="modal-btn-update">
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Order;
